module.exports = __webpack_public_path__ + "static/img/6.65b0c19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/sky101/6.png
// module id = X4qy
// module chunks = 1